// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* subnav */
.subnav {
  display: flex;
  font-size: 1.5rem;
  justify-content: space-around;
  padding-bottom: 50px;
  padding-top: 50px;
  margin-bottom: 70px;
  border-bottom: solid 1px #000000;
}

.subnav a:hover {
  text-decoration: none;
  color: #cacaca;
}

.subnav a:link {
  text-decoration: none;
  color: #000000;
}

.subnav a:active {
  text-decoration: none;
  color: #6e6e6e;
}

.subnav a:visited {
  text-decoration: none;
  color: #000000;
}

/* aboutcontent */
.aboutcontent {
  position: relative;
  width: 100%;
  height: 1200px;
  overflow: hidden;
}

.lcircle1 {
  position: absolute;
  top: 1%;
  left: 10%;
  width: 300px;
  height: 300px;
  border-radius: 50%;
  background-color: #cacaca;
  z-index: 3;
}

.lcircle2 {
  position: absolute;
  top: 23%;
  left: 15%;
  width: 250px;
  height: 250px;
  border-radius: 50%;
  background-color: rgba(36, 36, 36, 0.5490196078);
  z-index: 4;
}

.lcircle3 {
  position: absolute;
  top: 8%;
  left: -5%;
  width: 500px;
  height: 500px;
  border-radius: 50%;
  background-color: #e40404;
  z-index: 1;
}

.lcircle4 {
  position: absolute;
  top: 35%;
  left: 7%;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background-color: #494949;
  z-index: 4;
}

.rcircle1 {
  position: absolute;
  top: 60%;
  right: 1%;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background-color: #cacaca;
  z-index: 1;
}

.rcircle2 {
  position: absolute;
  top: 80%;
  right: 5%;
  width: 300px;
  height: 300px;
  border-radius: 50%;
  background-color: rgba(36, 36, 36, 0.5490196078);
  z-index: 3;
}

.rcircle3 {
  position: absolute;
  top: 65%;
  right: -10%;
  width: 500px;
  height: 500px;
  border-radius: 50%;
  background-color: var(--primary_color);
  z-index: 2;
}

.rcircle4 {
  position: absolute;
  top: 90%;
  right: 16%;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background-color: #242424;
  z-index: 1;
}

.bggirl {
  position: absolute;
  left: 0;
  top: -3%;
  z-index: 4;
}

.bggirl img {
  width: 400px;
}

.bgboy {
  position: absolute;
  right: 12%;
  top: 45%;
}

@media (max-width: 1780px) {
  .lcircle1 {
    display: none;
  }
  .lcircle2 {
    display: none;
  }
  .lcircle3 {
    display: none;
  }
  .lcircle4 {
    display: none;
  }
  .rcircle1 {
    display: none;
  }
  .rcircle2 {
    display: none;
  }
  .rcircle3 {
    display: none;
  }
  .rcircle4 {
    display: none;
  }
  .bggirl {
    display: none;
  }
  .bgboy {
    display: none;
  }
}
.bgboy img {
  width: 400px;
}

.textarea1 {
  position: absolute;
  top: 5%;
  right: 20%;
  width: 800px;
}

.textarea2 {
  position: absolute;
  top: 55%;
  left: 16%;
  width: 800px;
}

@media (max-width: 1200px) {
  .textarea1 {
    position: absolute;
    left: 50%;
    transform: translate(-60%, 0);
    width: 80%;
    margin: 3rem;
  }
  .textarea2 {
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    width: 80%;
  }
}
.textarea3 {
  margin-bottom: 10rem;
}

.textarea4 {
  width: 100%;
  margin-bottom: 8rem;
}

.imgarea {
  margin-bottom: 5rem;
}

.imgarea img {
  width: 100%;
  object-fit: contain;
  margin-bottom: 3rem;
}

.titlename {
  font-size: 2rem;
  font-weight: 900;
  margin-bottom: 3rem;
}

/* Glory */
.videoctrl {
  width: 100%;
  opacity: 0.5;
}

.videoctrl video {
  width: 100%;
}

/* ==== Mobile：把絕對定位改回正常排版 ==== */
@media (max-width: 992px) {
  /* 1) 容器別用固定高度，讓內容撐開 */
  .aboutcontent {
    position: static; /* 不用相對定位也可 */
    height: auto; /* 取代原本的 1200px */
    min-height: unset;
    overflow: visible;
    padding: 0 16px;
  }
  /* 2) 文字區塊改回正常文件流，100% 寬、取消 transform */
  .textarea1,
  .textarea2,
  .textarea3,
  .textarea4 {
    position: static !important;
    width: 100% !important;
    margin: 0 0 2rem 0 !important;
    transform: none !important;
    right: auto !important;
    left: auto !important;
    top: auto !important;
  }
  /* 3) 裝飾物與左右大圖在手機隱藏（避免擠版） */
  .lcircle1, .lcircle2, .lcircle3, .lcircle4,
  .rcircle1, .rcircle2, .rcircle3, .rcircle4,
  .bggirl, .bgboy {
    display: none !important;
  }
  /* 4) 圖片區域：保持等比縮放 */
  .imgarea img {
    width: 100%;
    height: auto;
    object-fit: contain;
  }
  /* 5) subnav 在手機收緊一些間距與字級 */
  .subnav {
    flex-wrap: wrap;
    gap: 8px;
    font-size: 1.125rem; /* ~18px */
    padding: 24px 0;
    margin-bottom: 32px;
  }
  /* 6) banner 上的絕對定位文案/形狀可關閉（若需要） */
  .bannercircle,
  .aboutbannertext {
    display: none !important;
  }
  .banner img {
    width: 100%;
    height: auto;
    object-fit: cover;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/about/styles/origin.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,WAAA;AACA;EACI,aAAA;EACA,iBAAA;EACA,6BAAA;EACA,oBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gCAAA;AAEJ;;AAAA;EACI,qBAAA;EACA,cAAA;AAGJ;;AADA;EACI,qBAAA;EACA,cAAA;AAIJ;;AAFA;EACI,qBAAA;EACA,cAAA;AAKJ;;AAHA;EACI,qBAAA;EACA,cAAA;AAMJ;;AAJA,iBAAA;AACA;EACI,kBAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;AAOJ;;AALA;EACI,kBAAA;EACA,OAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,UAAA;AAQJ;;AANA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gDAAA;EACA,UAAA;AASJ;;AAPA;EACI,kBAAA;EACA,OAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,UAAA;AAUJ;;AARA;EACI,kBAAA;EACA,QAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,UAAA;AAWJ;;AARA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,UAAA;AAWJ;;AATA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gDAAA;EACA,UAAA;AAYJ;;AAVA;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,sCAAA;EACA,UAAA;AAaJ;;AAXA;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,UAAA;AAcJ;;AAZA;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;AAeJ;;AAbA;EACI,YAAA;AAgBJ;;AAdA;EACI,kBAAA;EACA,UAAA;EACA,QAAA;AAiBJ;;AAfA;EACI;IACI,aAAA;EAkBN;EAhBE;IACI,aAAA;EAkBN;EAhBE;IACI,aAAA;EAkBN;EAhBE;IACI,aAAA;EAkBN;EAfE;IACI,aAAA;EAiBN;EAfE;IACI,aAAA;EAiBN;EAfE;IACI,aAAA;EAiBN;EAfE;IACI,aAAA;EAiBN;EAfE;IACI,aAAA;EAiBN;EAdE;IACI,aAAA;EAgBN;AACF;AAdA;EACI,YAAA;AAgBJ;;AAdA;EACI,kBAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;AAiBJ;;AAfA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;AAkBJ;;AAhBA;EACI;IACI,kBAAA;IACA,SAAA;IACA,6BAAA;IACA,UAAA;IACA,YAAA;EAmBN;EAjBE;IACI,kBAAA;IACA,SAAA;IACA,6BAAA;IACA,UAAA;EAmBN;AACF;AAjBA;EACI,oBAAA;AAmBJ;;AAjBA;EACI,WAAA;EACA,mBAAA;AAoBJ;;AAlBA;EACI,mBAAA;AAqBJ;;AAnBA;EACI,WAAA;EACA,mBAAA;EACA,mBAAA;AAsBJ;;AApBA;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AAuBJ;;AArBA,UAAA;AACA;EACI,WAAA;EACA,YAAA;AAwBJ;;AAtBA;EACI,WAAA;AAyBJ;;AAtBA,iCAAA;AACA;EACI,sBAAA;EACA;IACE,gBAAA,EAAA,aAAA;IACA,YAAA,EAAA,iBAAA;IACA,iBAAA;IACA,iBAAA;IACA,eAAA;EAyBJ;EAtBE,uCAAA;EACA;;;;IAIE,2BAAA;IACA,sBAAA;IACA,6BAAA;IACA,0BAAA;IACA,sBAAA;IACA,qBAAA;IACA,oBAAA;EAwBJ;EArBE,2BAAA;EACA;;;IAGE,wBAAA;EAuBJ;EApBE,mBAAA;EACA;IACE,WAAA;IACA,YAAA;IACA,mBAAA;EAsBJ;EAnBE,2BAAA;EACA;IACE,eAAA;IACA,QAAA;IACA,mBAAA,EAAA,UAAA;IACA,eAAA;IACA,mBAAA;EAqBJ;EAlBE,kCAAA;EACA;;IAEE,wBAAA;EAoBJ;EAlBE;IACE,WAAA;IACA,YAAA;IACA,iBAAA;EAoBJ;AACF","sourcesContent":["/* subnav */\n.subnav {\n    display: flex;\n    font-size: 1.5rem;\n    justify-content: space-around;\n    padding-bottom: 50px;\n    padding-top: 50px;\n    margin-bottom: 70px;\n    border-bottom: solid 1px #000000;\n}\n.subnav a:hover {\n    text-decoration: none;\n    color: #cacaca;\n}\n.subnav a:link {\n    text-decoration: none;\n    color: #000000;\n}\n.subnav a:active {\n    text-decoration: none;\n    color: #6e6e6e;\n}\n.subnav a:visited {\n    text-decoration: none;\n    color: #000000;\n}\n/* aboutcontent */\n.aboutcontent {\n    position: relative;\n    width: 100%;\n    height: 1200px;\n    overflow: hidden;\n}\n.lcircle1 {\n    position: absolute;\n    top: 1%;\n    left: 10%;\n    width: 300px;\n    height: 300px;\n    border-radius: 50%;\n    background-color: #cacaca;\n    z-index: 3;\n}\n.lcircle2 {\n    position: absolute;\n    top: 23%;\n    left: 15%;\n    width: 250px;\n    height: 250px;\n    border-radius: 50%;\n    background-color: #2424248c;\n    z-index: 4;\n}\n.lcircle3 {\n    position: absolute;\n    top: 8%;\n    left: -5%;\n    width: 500px;\n    height: 500px;\n    border-radius: 50%;\n    background-color: #e40404;\n    z-index: 1;\n}\n.lcircle4 {\n    position: absolute;\n    top: 35%;\n    left: 7%;\n    width: 200px;\n    height: 200px;\n    border-radius: 50%;\n    background-color: #494949;\n    z-index: 4;\n}\n\n.rcircle1 {\n    position: absolute;\n    top: 60%;\n    right: 1%;\n    width: 200px;\n    height: 200px;\n    border-radius: 50%;\n    background-color: #cacaca;\n    z-index: 1;\n}\n.rcircle2 {\n    position: absolute;\n    top: 80%;\n    right: 5%;\n    width: 300px;\n    height: 300px;\n    border-radius: 50%;\n    background-color: #2424248c;\n    z-index: 3;\n}\n.rcircle3 {\n    position: absolute;\n    top: 65%;\n    right: -10%;\n    width: 500px;\n    height: 500px;\n    border-radius: 50%;\n    background-color: var(--primary_color);\n    z-index: 2;\n}\n.rcircle4 {\n    position: absolute;\n    top: 90%;\n    right: 16%;\n    width: 200px;\n    height: 200px;\n    border-radius: 50%;\n    background-color: #242424;\n    z-index: 1;\n}\n.bggirl {\n    position: absolute;\n    left: 0;\n    top: -3%;\n    z-index: 4;\n}\n.bggirl img {\n    width: 400px;\n}\n.bgboy {\n    position: absolute;\n    right: 12%;\n    top: 45%;\n}\n@media (max-width:1780px) {\n    .lcircle1 {\n        display: none;\n    }\n    .lcircle2 {\n        display: none;\n    }\n    .lcircle3 {\n        display: none;\n    }\n    .lcircle4 {\n        display: none;\n    }\n    \n    .rcircle1 {\n        display: none;\n    }\n    .rcircle2 {\n        display: none;\n    }\n    .rcircle3 {\n        display: none;\n    }\n    .rcircle4 {\n        display: none;\n    }\n    .bggirl {\n        display: none;\n    }\n    \n    .bgboy {\n        display: none;\n    }\n}\n.bgboy img{\n    width: 400px;\n}\n.textarea1 {\n    position: absolute;\n    top: 5%;\n    right: 20%;\n    width: 800px;\n}\n.textarea2 {\n    position: absolute;\n    top: 55%;\n    left: 16%;\n    width: 800px;\n}\n@media (max-width:1200px) {\n    .textarea1 {\n        position: absolute; \n        left: 50%;\n        transform: translate(-60%, 0);\n        width: 80%;\n        margin: 3rem;\n    }\n    .textarea2 {\n        position: absolute; \n        left: 50%;\n        transform: translate(-50%, 0);\n        width: 80%;\n    }\n}\n.textarea3 {\n    margin-bottom: 10rem;\n}\n.textarea4 {\n    width: 100%;\n    margin-bottom: 8rem;\n}\n.imgarea {\n    margin-bottom: 5rem;\n}\n.imgarea img{\n    width: 100%;\n    object-fit: contain;\n    margin-bottom: 3rem;\n}\n.titlename {\n    font-size: 2rem;\n    font-weight: 900;\n    margin-bottom: 3rem;\n}\n/* Glory */\n.videoctrl {\n    width: 100%;\n    opacity: 0.5;\n}\n.videoctrl video{\n    width: 100%;\n}\n\n/* ==== Mobile：把絕對定位改回正常排版 ==== */\n@media (max-width: 992px) {\n    /* 1) 容器別用固定高度，讓內容撐開 */\n    .aboutcontent {\n      position: static;        /* 不用相對定位也可 */\n      height: auto;            /* 取代原本的 1200px */\n      min-height: unset;\n      overflow: visible;\n      padding: 0 16px;\n    }\n  \n    /* 2) 文字區塊改回正常文件流，100% 寬、取消 transform */\n    .textarea1,\n    .textarea2,\n    .textarea3,\n    .textarea4 {\n      position: static !important;\n      width: 100% !important;\n      margin: 0 0 2rem 0 !important;\n      transform: none !important;\n      right: auto !important;\n      left: auto !important;\n      top: auto !important;\n    }\n  \n    /* 3) 裝飾物與左右大圖在手機隱藏（避免擠版） */\n    .lcircle1, .lcircle2, .lcircle3, .lcircle4,\n    .rcircle1, .rcircle2, .rcircle3, .rcircle4,\n    .bggirl, .bgboy {\n      display: none !important;\n    }\n  \n    /* 4) 圖片區域：保持等比縮放 */\n    .imgarea img {\n      width: 100%;\n      height: auto;\n      object-fit: contain;\n    }\n  \n    /* 5) subnav 在手機收緊一些間距與字級 */\n    .subnav {\n      flex-wrap: wrap;\n      gap: 8px;\n      font-size: 1.125rem;   /* ~18px */\n      padding: 24px 0;\n      margin-bottom: 32px;\n    }\n  \n    /* 6) banner 上的絕對定位文案/形狀可關閉（若需要） */\n    .bannercircle,\n    .aboutbannertext {\n      display: none !important;\n    }\n    .banner img {\n      width: 100%;\n      height: auto;\n      object-fit: cover;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
